import axios from "axios";
import store from "@/store";
import type from "@/constants/types";
// import SocketFactory from "@/socket";
import Cookies from "js-cookie";

const request = async (
  typeOfReq,
  pathReq,
  bodyReq = {},
  urlType = process.env.VUE_APP_SITE_URL,
  uploadPercentage = false
) => {
  let urlPrefix = process.env.VUE_APP_SITE_URL;
  urlPrefix += "/api/v1/";

  const url = `${urlPrefix}${pathReq}`;

  var deviceToken = sessionStorage.tabID ? sessionStorage.tabID : (sessionStorage.tabID = Math.random());
  deviceToken = "TOKEN_" + deviceToken.toString();

  let response = null;

  let config = {
    headers: {
      Authorization: window.localStorage.getItem("token"),
      device: deviceToken,
    },
  };

  if (typeOfReq === "GET") {
    try {
      response = await axios.get(url, config).catch((e) => {
        console.error("Error for request GET: ", url);
        if (e.message.includes("401")) {
          removeAllData();
        } else if (e.message.includes("403")) {
          removeAllData();
        }
      });
      return response;
    } catch (error) {
      console.error("Error for request GET: ", url);
    }
  }

  if (typeOfReq === "POST") {
    try {
      response = await axios.post(url, bodyReq, config).catch((e) => {
        console.error("Error for request POST: ", url);
        if (e.message.includes("401")) {
          removeAllData();
        }
      });
      return response;
    } catch (error) {
      console.error("Error for request POST: ", url);
    }
  }

  if (typeOfReq === "POST" && uploadPercentage) {
    // let uploadPercentage = null;
    try {
      response = await axios
        .post(url, bodyReq, {
          ...config,
          onUploadProgress: (progressEvent) => {
            uploadPercentage = parseInt(Math.round(progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .catch((e) => {
          console.error("Error for request POST: ", url);
          if (e.message.includes("401")) {
            // window.location.replace("/login");
            removeAllData();
          }
        });
      console.log("upload response", response);
      return response;
    } catch (error) {
      console.error("Error for request POST: ", url);
    }
  }

  if (typeOfReq === "PUT") {
    try {
      response = await axios.put(url, bodyReq, config).catch((e) => {
        console.error("Error for request PUT: ", url);
        if (e.message.includes("401")) {
          // window.location.replace("/login");
          removeAllData();
        }
      });
      return response;
    } catch (error) {
      console.error("Error for request PUT: ", url);
    }
  }

  if (typeOfReq === "DELETE") {
    try {
      if (bodyReq) {
        response = await axios
          .delete(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: window.localStorage.getItem("token"),
            },
            data: bodyReq,
          })
          .catch((e) => {
            console.error("Error for request DELETE: ", url);
            if (e.message.includes("401")) {
              removeAllData();
            }
          });
        return response;
      }
      response = await axios.delete(url, config).catch((e) => {
        console.error("Error for request DELETE: ", url);
        if (e.message.includes("401")) {
          removeAllData();
        }
      });
      return response;
    } catch (error) {
      console.error("Error for request DELETE: ", url);
    }
  }

  if (typeOfReq === "PATCH") {
    try {
      response = await axios.patch(url, bodyReq, config).catch((e) => {
        console.error("Error for request PATCH: ", url);
        if (e.message.includes("401")) {
          removeAllData();
        }
      });
      return response;
    } catch (error) {
      console.error("Error for request PATCH: ", url);
    }
  }
};

const removeAllData = () => {
  var referrer = window.localStorage.getItem("referrer");
  var language = window.localStorage.getItem("language");
  var theme = window.localStorage.getItem("theme");
  var show_preview_menu = window.localStorage.getItem("show_preview_menu");

  window.localStorage.clear();
  sessionStorage.clear();
  Cookies.remove("me");
  Cookies.remove("id");
  Cookies.remove("vuex");
  Cookies.remove("token");

  if (typeof referrer != "undefined" && referrer != null) {
    window.localStorage.setItem("referrer", referrer);
  }

  if (typeof language != "undefined" && language != null) {
    window.localStorage.setItem("language", language);
  }

  if (typeof theme != "undefined" && theme != null) {
    window.localStorage.setItem("theme", theme);
  }

  if (typeof show_preview_menu != "undefined" && show_preview_menu != null) {
    window.localStorage.setItem("show_preview_menu", show_preview_menu);
  }
  // SocketFactory.unsubscribeFromNotifications();
  store.dispatch({
    type: type.logout,
  });
  window.location.replace("/login");
};

export default request;
